import { IconButton, Stack } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from 'src/components/icons';

interface TestsTableActionsProps {
  item: Record<string, any>;
  onUpdate: (id: string | number) => void;
  onDelete: (id: string | number) => void;
}

export const TestsTableActions: ComponentType<TestsTableActionsProps> = ({
  item,
  onUpdate,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row">
      <IconButton
        color="primary"
        aria-label={t('application.confirm.title', 'Одобрить заявку')}
        size="small"
        onClick={() => onUpdate(item.id)}
      >
        <Icons.Pencil />
      </IconButton>

      <IconButton
        color="error"
        aria-label={t('application.decline.title', 'Отклонить заявку')}
        size="small"
        onClick={() => onDelete(item.id)}
      >
        <Icons.Close />
      </IconButton>
    </Stack>
  );
};
